import React from "react"
import PropTypes from "prop-types"

const SymbolLink = ({ fillColor, width, height }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.33397 1.52054C5.50119 0.917675 6.15898 0.24418 6.76252 0.0579034C7.14404 -0.0597859 8.06868 0.0116154 8.40368 0.184738C8.80017 0.389586 9.15414 0.754683 9.38924 1.20117L9.58245 1.56817L9.60508 3.44592L9.6277 5.3236L11.5724 5.34527C13.4053 5.3656 13.5332 5.37559 13.7981 5.51797C14.1973 5.7326 14.5778 6.12569 14.7966 6.5496C15.0488 7.03815 15.0695 7.87021 14.8418 8.36516C14.6273 8.83142 14.2327 9.23704 13.7743 9.46243L13.3766 9.65799L11.5013 9.67972L9.62602 9.70146L9.60424 11.5439L9.58245 13.3863L9.38713 13.7846C9.16201 14.2435 8.75688 14.6386 8.29119 14.8533C8.04282 14.9679 7.83421 15.0024 7.40436 14.9999C6.71011 14.9959 6.28166 14.8002 5.80479 14.2692C5.29491 13.7013 5.26139 13.5292 5.26139 11.4796V9.7035L3.41704 9.68078L1.57268 9.65799L1.21379 9.4684C1.01642 9.36415 0.710366 9.11787 0.533729 8.92118C0.112584 8.45218 -0.0360215 8.00731 0.00718916 7.34507C0.06122 6.51639 0.458757 5.91782 1.20184 5.54604L1.63022 5.33169H3.44584H5.26139L5.26181 3.55545C5.26202 2.56364 5.29385 1.66496 5.33397 1.52054Z"
      fill={fillColor}
    />
  </svg>
)

SymbolLink.propsTypes = {
  fillColor: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
}

SymbolLink.defaultProps = {
  fillColor: "#9EBD48",
  width: "15",
  height: "15",
}

export { SymbolLink }
